/**
 * Default fill alphas for the bounding-box overlay and the Pixi label prefix
 * used for the scale-step dimension boxes.
 */
export const BoundingBoxOverlay = {
	fillAlpha: 0.04,
	hoverFillAlpha: 0.12,
	scaleDimensionBoxLabelPrefix: 'scale-dimension-box|',
} as const;
